<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row" skf-if="$field.fieldName != 'enterprise' || $field.fieldInfo.openBusiness === 0">
                <input type="text" class="form-control text-fieldName"  skf-change="$parent.textChange('{{field.fieldName}}')" skf-value="$field.value">
            </div>
            <div class="form-row" skf-if="$field.fieldName == 'enterprise' && $field.fieldInfo.openBusiness === 1">
                <div class="c-form-select ent-select">
                       <input type="text" class="form-control text-fieldName" sk-event.input="inputChange('{{field.fieldName}}')" skf-value="$field.value">
                    <div class="select-mask"></div>
                    <div id="ent-select-main-wrap"></div>
                </div>
            </div>
            <div class="form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage"></div>

            <div class="form-row form-flex send-code" skf-if="$field.isSendSms == 1">
                <input type="text" class="form-control" skf-change="$parent.setCode('{{field.fieldName}}')" skf-value="$field.verificationCode">
                <input type="button"  class="send-button j-send-{{field.fieldName}}"
                       skf-value="$field.sendCodeJson.time == 0 ? '获取验证码' : $field.sendCodeJson.time + '秒'"
                       skf-disabled="$field.sendCodeJson.disabled"
                       skf-click="$parent.sendCode('{{field.fieldName}}', 'customForm')"/>
            </div>
            <div class="form-error" skf-if="$field.isSendSms == 1 && $field.verificationCodeDirty && $field.verificationCodeError">请输入验证码</div>
        </div>
    </div>
</div>